import BaseComponent from "../components/BaseComponent";
import {Panel, SplitCol, SplitLayout, View} from "@vkontakte/vkui";
import MainMenu from "../components/MainMenu";
import KlientsList from "../references/Klients/KlientsList";
import KlientsItem from "../references/Klients/item";
import SalePoint from "../references/Klients/salePoint";
import React from "react";
import * as constants from "../assets/constants";
import {AdaptivityContext} from "../assets/constants";
import KlientsApi from "../api/references/klients";

class FragmentKlients extends BaseComponent {

    constructor(props) {
        super(props)
        const state = {
            activePanelKlients: "panel_klients_list",
            current_klient: null,
            current_sale_point: null,
            current_sale_mall: null,
            getImageEventName: "setImage",

            // Сохраняем состояние списка клиентов при переключении панелей
            listState: null,
        }

        this.state = {
            ...this.state,
            ...state
        }
    }

    // Callback для сохранения состояния списка
    saveListState = (listState) => {
        this.setState({ listState })
    }

    editCurrentKlient = (e, fieldName) => {
        const {current_klient} = this.state
        //console.log(e)
        if (e.unrestricted_value !== undefined) {
            current_klient.INN = e.data.inn
            current_klient.title = e.value
            current_klient.dadata_object = e
        } else {
            current_klient[fieldName] = e.currentTarget.value
        }
        this.setState({current_klient})
    }

    editCurrentSalePoint = (e, fieldName) => {
        const {current_sale_point} = this.state
        ///console.log(e)
        if (e.unrestricted_value !== undefined) {
            current_sale_point.dadata_object = e
            current_sale_point.full_address = e.value
        } else {
            current_sale_point[fieldName] = e.currentTarget.value
        }
        this.setState({current_sale_point})
    }

    setCurrentSalePoint = (item) => {
        this.setState({current_sale_point: item})
    }

    render() {
        return <View activePanel={this.state.activePanelKlients}>
            <Panel id="panel_klients_list">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol>
                        <KlientsList 
                            current_user={this.props.current_user}
                            savedListState={this.state.listState}
                            onSaveListState={this.saveListState}
                        />
                    </SplitCol>

                </SplitLayout>
            </Panel>
            <Panel id="panel_klients_item">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol>
                        <KlientsItem
                            base_url={this.state.base_url}
                            current_user={this.props.current_user}
                            item={this.state.current_klient}
                            change={this.editCurrentKlient}
                            hideForm={() => this.setState({activePanelKlients: 'panel_klients_list'})}
                        />
                    </SplitCol>

                </SplitLayout>
            </Panel>
            <Panel id="panel_sale_point">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol>
                        <SalePoint
                            current_user={this.props.current_user}
                            base_url={this.state.base_url}
                            item={this.state.current_sale_point}
                            change={this.editCurrentSalePoint}
                            hideForm={() => this.setState({activePanelKlients: 'panel_klients_item'})}
                        />
                    </SplitCol>

                </SplitLayout>
            </Panel>

        </View>
    }

    receiveMessage = (event) => {

        if (event.data.type !== undefined && event.data.type === 'setCurrentKlient') {

            console.log(event)

            this.setState({
                current_klient: event.data.value,
                activePanelKlients: event.data.value !== null ? 'panel_klients_item' : 'panel_klients_list'
            })

            return
        }
        if (event.data.type !== undefined && event.data.type === 'reloadCurrentKlient' && this.state.current_klient.id > 0) {
            KlientsApi.getOne(this.state.current_klient.id).then(response => {
                const {data} = response

                if (data.id) {
                    this.setState({current_klient: data, activePanelKlients: 'panel_klients_item'})
                }
            })

            return
        }
        if (event.data.type !== undefined && event.data.type === 'setCurrentSalePoint') {


            this.setState({
                current_sale_point: event.data.value,
                activePanelKlients: event.data.value && event.data.value.id ? 'panel_sale_point' : 'panel_klients_item'
            })

            return
        }
    }
}

export default FragmentKlients